module.exports = __webpack_public_path__ + "img/jersey.8fb759f2.svg";